import { Suspense, useMemo } from "react";
import { useIntl } from "react-intl";

import { calculateMargin } from "lib/Math";
import Suspender from "lib/Suspender";

import { LoadingSkeleton } from "@joor/design-system";
import { asMaybeNumber } from "lib/conversions";
import { isNumber } from "lodash";
import { WorkspaceFinancialsPriceLevelFragment } from "operations";
import { StyledContent, StyledLabel, StyledTitle } from "./styledComponents";

const opts = {
  style: "percent" as const,
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
};

type PriceLevel = Omit<WorkspaceFinancialsPriceLevelFragment, "id">;

type Props = {
  loading: boolean;
  rollup: PriceLevel[] | undefined;
  moreCurrencies: boolean;
};
export const Margin = (props: Props) => {
  const intl = useIntl();

  const listMargin =
    props.rollup &&
    props.rollup.map((pl) => {
      const parsedCost = asMaybeNumber(pl.extCost);
      const parsedRetail = asMaybeNumber(pl.extRetail);
      return (
        <StyledTitle data-testid="margin-value">
          {isNumber(parsedCost) && isNumber(parsedRetail)
            ? intl.formatNumber(calculateMargin(parsedCost, parsedRetail), opts)
            : "-"}
        </StyledTitle>
      );
    });

  const margin = useMemo(() => {
    const parsedCost = props?.rollup
      ? asMaybeNumber(props.rollup[0]?.extCost)
      : 0;
    const parsedRetail = props?.rollup
      ? asMaybeNumber(props.rollup[0]?.extRetail)
      : 0;
    return isNumber(parsedCost) && isNumber(parsedRetail)
      ? intl.formatNumber(calculateMargin(parsedCost, parsedRetail), opts)
      : null;
  }, [props, intl]);
  return (
    <StyledContent>
      <StyledLabel>Final Margin</StyledLabel>
      <Suspense fallback={<LoadingSkeleton />}>
        <Suspender suspend={props.loading}>
          {props.moreCurrencies ? (
            listMargin
          ) : (
            <StyledTitle data-testid="margin-value">
              {margin ?? "-"}
            </StyledTitle>
          )}
        </Suspender>
      </Suspense>
    </StyledContent>
  );
};
